import { Col, Row, Typography } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { statusColor } from '~/pages/agent/components/agent/tableElements/cells/StatusCell';
import colors from '~/constants/colors';
import { getApplicationKey, useGetApplication } from '~/controllers/wizard';
import { useDirection } from '~/hooks/i18nHooks';
import { CircleIcon } from '~/img';
import direction from '~/utils/direction';
import { queryClient } from '~/index';
import RiskLevelSelect from '~/components/inputs/RiskLevelSelect';

const HeaderCompanyName: FC = () => {
  const applicationQuery = useGetApplication();
  const status = applicationQuery.data?.label;

  const info: any = applicationQuery.data?.payload?.provided?.companyInformation;

  const legalName = info?.legalName;
  const dir = useDirection();

  return (
    <div className="HeaderCompanyName">
      <Row gutter={8} justify="space-between">
        <Col span={24} sm={12} md={24} flex={1}>
          <Container dir={dir}>
            <Typography.Text className="HeaderCompanyName-LegalName" ellipsis>
              {legalName}
            </Typography.Text>
            <CircleIcon style={{ color: status ? statusColor(status) : colors.blue[1100] }} />
          </Container>
        </Col>
        <Col span={24} sm={12} md={24}>
          <RiskLevelSelect
            type="APPLICATION"
            disabled={status !== 'onReview'}
            currentValue={applicationQuery?.data?.riskLevel}
            recordId={applicationQuery?.data?.uid}
            onAfterChange={() => {
              void queryClient.invalidateQueries(getApplicationKey);
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  .HeaderCompanyName-LegalName {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
    ${direction.margin.right(8)};
  }
`;

export default HeaderCompanyName;
